module.exports = __webpack_public_path__ + "img/section5_bg.fd6d651b.png";